import { useCalendarEvents } from '@/domains/investor/event-calendar/composables/useCalendarEvents'
import { EVENTS_PER_PAGE } from '@/domains/investor/event-calendar/const/event-calendar-view.const'
import { queryParam, useQueryState } from '@/domains/investor/composables/useQueryState'

export const useEventCalendarView = async () => {
  const { page } = useQueryState({ page: queryParam.page() })

  const { events, total, isLoading } = await useCalendarEvents()

  const paginatedEvents = computed(() => {
    const start = (page.value - 1) * EVENTS_PER_PAGE

    return events.value.slice(start, start + EVENTS_PER_PAGE)
  })

  return {
    page,
    perPage: EVENTS_PER_PAGE,
    events: paginatedEvents,
    total,
    isLoading,
  }
}
